/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import overlayMixin from "../mixins/overlay-mixin";
import template from "templates/modules/overlays/shipping_and_returns_overlay";
import rothko from "modules/rothko";
import logging from "utils/logging";

export default baustein.register("shipping-and-returns-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        // overlay-mixin options
        overlaySize: "medium",
        noContentPadding: false,

        // shipping & returns overlay options
        linkId: null
    },

    onOverlayCloseIntent() {
        this.close();
    },

    getOverlayContent() {
        const linkId = this.options.linkId;
        const options = {
            link_id: linkId
        };

        return rothko
            .fetch("modules/overlays/shipping_and_returns_overlay", options)
            .then(overlayContext => {
                return template({
                    shipping_and_returns_overlay: overlayContext
                });
            })
            .catch(err => {
                logging.error(err);
            });
    }
});

